import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 搜索");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确 定");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getMerInfoList } from '@/request';
import { jsonStringify } from '@/utils';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddProductModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    actProductList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'selected'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      prodkeyword: ''
    });
    const table = ref();
    watch(() => props.modelValue, newVal => {
      if (!newVal) {
        form.value.prodkeyword = '';
        table.value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      pagerConfig: {
        pageSize: 5
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '商品编码',
        field: 'prodNo',
        width: '250px'
      }, {
        title: '商品名称',
        field: 'prodName',
        width: '250px'
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: '150px',
        showOverflow: 'tooltip'
      }, {
        title: '厂家',
        field: 'manufacture',
        width: '150px',
        showOverflow: 'tooltip'
      }],
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return !row.checkbox;
        }

      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getMerInfoList(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value), {}, {
              prodNoS: jsonStringify(props.actProductList.map(prod => prod.prodNo))
            })).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage({
          showClose: true,
          message: '请勾选商品后再进行操作!',
          type: 'warning'
        });
        return;
      }

      emit('selected', selectRows);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "挑选商品",
        width: "800px",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.prodkeyword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.prodkeyword = $event),
              placeholder: "请输入标品编码/商品名称/厂家搜索"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Search",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};